// extracted by mini-css-extract-plugin
export var sliderWrapper = "MobileContent-module--sliderWrapper--d2b86";
export var slide = "MobileContent-module--slide--aae0c";